'use strict';

function getMask(maskId, svgId, svg, attributes, isClip) {
    var width = attributes.width,
        height = attributes.height,
        x = attributes.x,
        y = attributes.y,
        transform = attributes.transform,
        style = attributes.style;

    var transformStr = transform ? ' transform="' + transform + '"' : '';
    var styleStr = style ? ' style="' + style + '"' : '';
    return (isClip ? '<style>#' + svgId + ' * {fill: #fff; stroke: #fff; stroke-width: 0;}</style>' : '') + '\n<mask id="' + maskId + '">\n    <use id="' + svgId + '-use" xlink:href="#' + svgId + '" width="' + width + '" height="' + height + '" x="' + x + '" y="' + y + '"' + transformStr + styleStr + '></use>\n</mask>\n' + svg + '\n';
}

module.exports = {
    getMask: getMask
};
//# sourceMappingURL=svgMask.js.map